import { getBackendUrl } from "../config";

export const resolveContactAvatar = (contact) => {
  try {
    const url = contact?.urlPicture || contact?.profilePicUrl || "";
    if (typeof url === "string" && url.trim() !== "") {
      const cleanUrl = url.trim();
      
      if (cleanUrl.includes("user//") || cleanUrl.includes("//static/media")) {
        return "/nopicture.png";
      }
      
      if (cleanUrl.startsWith("http://") || cleanUrl.startsWith("https://")) {
        return cleanUrl;
      }
      
      if (cleanUrl.startsWith("/public/")) {
        return `${getBackendUrl()}${cleanUrl}`;
      }
      
      if (cleanUrl.startsWith("/")) {
        return cleanUrl;
      }
      
      return `/${cleanUrl}`;
    }
  } catch (e) {
    // noop
  }
  return "/nopicture.png";
};

export const hasCustomAvatar = (contact) => {
  const url = resolveContactAvatar(contact);
  if (!url) return false;
  return !(url.includes("nopicture.png") || url.endsWith("/nopicture.png"));
};

export const resolveTicketContactAvatar = (ticket) => {
  return resolveContactAvatar(ticket?.contact);
};

export const resolveStaticUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const clean = url.trim();
  if (!clean) return null;
  if (clean.startsWith("http://") || clean.startsWith("https://")) return clean;
  if (clean.startsWith("/public/")) return `${getBackendUrl()}${clean}`;
  return clean;
};

/**
 * Resolve avatar URL para usuários
 * @param {string} profileImage - Nome do arquivo de imagem do perfil
 * @param {number} companyId - ID da empresa
 * @param {string} backendUrl - URL base do backend
 * @returns {string} URL válida do avatar ou /nopicture.png
 */
export const resolveUserAvatar = (profileImage, companyId, backendUrl) => {
  try {
    // Se não tem imagem ou está vazio, retornar padrão
    if (!profileImage || typeof profileImage !== "string" || profileImage.trim() === "") {
      return "/nopicture.png";
    }
    
    const cleanImage = profileImage.trim();
    
    // ✅ Validar se não contém caminhos inválidos
    if (cleanImage.includes("//") || cleanImage.includes("user//") || cleanImage.includes("static/media")) {
      return "/nopicture.png";
    }
    
    // Se já é uma URL completa, retornar como está
    if (cleanImage.startsWith("http://") || cleanImage.startsWith("https://") || cleanImage.startsWith("/")) {
      // Mas ainda validar se não tem caminhos inválidos
      if (cleanImage.includes("user//") || cleanImage.includes("//static/media")) {
        return "/nopicture.png";
      }
      return cleanImage;
    }
    
    // Construir URL completa
    if (!backendUrl) {
      return "/nopicture.png";
    }
    
    return `${backendUrl}/public/company${companyId}/user/${cleanImage}`;
  } catch (e) {
    // noop
  }
  return "/nopicture.png";
};
